import React from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import {withFormik} from 'formik';
import {object, array, string, ref} from 'yup';
import Button from "@material-ui/core/Button";

import i18n from '../../i18n';
import {mergeWithDefault} from "../Form/utils";
import FormField from '../Form/FormField';
import FormSelect from '../Form/FormSelect';

const InnerForm = ({canEditRoles, roles, values, isEdit, errors, touched, setFieldValue, handleChange, handleBlur, handleSubmit, isSubmitting, cancelUrl}) => (
    <form onSubmit={handleSubmit}>
        <FormField
            label={i18n.get('user.form.name')}
            type="text"
            name="name"
            error={errors.name}
            touched={touched.name}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.name}
        />

        <FormField
            label={i18n.get('user.form.email')}
            type="email"
            name="email"
            error={errors.email}
            touched={touched.email}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
        />

        {!isEdit &&
            <FormField
                label={i18n.get('user.form.password')}
                type="password"
                name="password"
                error={errors.password}
                touched={touched.password}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
            />
        }

        {!isEdit &&
            <FormField
                label={i18n.get('user.form.password_confirm')}
                type="password"
                name="password_confirm"
                error={errors.password_confirm}
                touched={touched.password_confirm}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password_confirm}
            />
        }

        {/*{canEditRoles && (*/}
            <FormSelect
                label={i18n.get('user.form.roles')}
                multiple
                name="roleNames"
                error={errors.roleNames}
                touched={touched.roleNames}
                onChange={selectedOptions =>
                    setFieldValue(
                        "roleNames",
                        selectedOptions.map(option => option.value)
                    )
                }
                onBlur={handleBlur}
                options={roles.map(value => ({label: value.name, value: value.name}))}
                value={values.roleNames}
            />
        {/*)}*/}

        <Button
            disabled={isSubmitting}
            variant="contained"
            color="primary"
            type="submit"
        >
            {i18n.get('user.submit')}
        </Button>
    </form>
);

const UserForm = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            email: '',
            name: '',
            roleNames: [],
            password: '',
            password_confirm: '',
        });
    },
    validationSchema: object().shape({
        email: string()
            .email(i18n.get('validation.email', {attribute: i18n.get('user.form.email')}))
            .required(i18n.get('validation.required', {attribute: i18n.get('user.form.email')})),
        name: string()
            .required(i18n.get('validation.required', {attribute: i18n.get('user.form.name')})),
        roleNames: array().ensure(),
        password: string()
            .min(6, i18n.get('validation.min.numeric', {attribute: i18n.get('user.form.password'), min: 6})),
        password_confirm: string()
            .oneOf([ref('password'), null], i18n.get('validation.confirmed', {attribute: i18n.get('user.form.password')}))
            .min(6, i18n.get('validation.min.numeric', {attribute: i18n.get('user.form.password_confirm'), min: 6})),
    }),
    handleSubmit: (
        values,
        {
            props,
            setSubmitting,
            setErrors,
        }
    ) => {
        setSubmitting(true);

        axios({
            method: props.method,
            url: props.url,
            data: values,
        })
            .then(response => {
                setSubmitting(false);

                // Show success message.
                swal({
                    text: i18n.get('user.saved.success'),
                    icon: "success",
                }).then(() => {
                    window.location.href = '/users'
                })
            })
            .catch(error => {
                setSubmitting(false);

                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                }
                // Show error message.
                return swal({
                    text: i18n.get('user.saved.error'),
                    icon: "error",
                });
            });
    },
})(InnerForm);

export default UserForm;



// WEBPACK FOOTER //
// ./resources/assets/js/components/User/Form.js